var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-6-item"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"item-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }